// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 *优惠券 类型
 */
export function couponCategory(status) {
  var statusMap = {
    1: '店铺',
    2: '商品',
    3: '通用',
    4: '品类',
    5: '品牌',
    6: '跨店'
  };
  return statusMap[status];
}